export var toNumber = function (numbers) {
    var validNumbers = numbers.filter(function (it) { return typeof it === 'number'; });
    return validNumbers
        .map(function (it, index) {
        return (it !== null && it !== void 0 ? it : 1) * Math.pow(10, validNumbers.length - index - 1);
    })
        .reduce(function (acc, curr) { return acc + curr; }, 0);
};
